var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { class: { promos: _setup.promotions }, attrs: { id: "section-hero" } },
    [
      _c(_setup.StatusAlertBanner),
      _vm._v(" "),
      _setup.promotions
        ? _c(
            _setup.MainSectionNavbarPromotions,
            _vm._b(
              {},
              "MainSectionNavbarPromotions",
              { promotions: _setup.promotions },
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "TransitionGroup",
        { staticClass: "scene-wrapper", attrs: { tag: "div", appear: "" } },
        _vm._l(
          _setup.PARALLAX_LAYER_CONFIGS,
          function ({ className, key, ...props }) {
            return _c(
              _setup.ParallaxLayer,
              _vm._b(
                {
                  key: key,
                  ref: "parallaxLayers",
                  refInFor: true,
                  class: className,
                  attrs: { id: `hero-scene-${key}` },
                },
                "ParallaxLayer",
                props,
                false
              )
            )
          }
        ),
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "logo-wrapper" },
        [
          _c(
            "Transition",
            { attrs: { appear: "" } },
            [
              _setup.showLogo
                ? _c(_setup.ZephyrLogo, {
                    attrs: { id: "hero-logo", animate: "" },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c(
            "b-button",
            {
              attrs: {
                id: "logo-tagline",
                variant: "alt-primary",
                to: { name: "individuals" },
              },
            },
            [_vm._v("\n      Purchase\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { attrs: { id: "logo-tagline" } }, [
      _c("h2", [_vm._v("Cutting Edge Drone Simulator")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }